import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { FaImage } from "react-icons/fa"; // You can change the icon

function LazyImage({
  srcWebp,
  srcFallback,
  alt,
  width = "100%",
  height = "auto",
  imageClasses,
}) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [loaded, setLoaded] = useState(false);

  return (
    <div
      ref={ref}
      className="p-1"
      style={{
        width,
        height,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {!loaded && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "2rem",
            color: "#aaa",
          }}
        >
          <FaImage />
        </div>
      )}

      {inView && (
        <picture className="bg-slate-50">
          <source srcSet={srcWebp} type="image/webp" />
          <img
            className={imageClasses}
            src={srcFallback}
            alt={alt}
            onLoad={() => setLoaded(true)}
            style={{
              objectFit: "cover",
              opacity: loaded ? 1 : 0,
              transition: "opacity 0.5s ease-in-out",
              display: "block",
            }}
          />
        </picture>
      )}
    </div>
  );
}

export default LazyImage;
